import React, { useCallback } from "react";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";

import { clearProviderSession } from "../../../services/session";
import { ProviderProvider } from "../../../provider/ProviderContext";
import ProviderShell from "../../../provider/ProviderShell";
import HomePage from "../../../provider/HomePage";
import EvaluationsPage from "../../../provider/EvaluationsPage";
import ServicesPage from "../../../provider/ServicesPage";
import ShopPage from "../../../provider/ShopPage";

// Area da oficina: a mesma moldura da area do cliente (AppShell), para celular e desktop.
function Provider({ history }) {
    const handleMissingSession = useCallback(() => {
        clearProviderSession();
        history.push('/provider/login');
    }, [history]);

    return (
        <ProviderProvider onMissingSession={handleMissingSession}>
            <ProviderShell>
                <Switch>
                    <Route path="/provider/home" component={HomePage} />
                    <Route path="/provider/evaluated" component={EvaluationsPage} />
                    <Route path="/provider/my-config" component={ServicesPage} />
                    <Route path="/provider/my-data" component={ShopPage} />
                    <Redirect to="/provider/home" />
                </Switch>
            </ProviderShell>
        </ProviderProvider>
    );
}

export default withRouter(Provider)
